import React, { FC } from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { Field } from 'formik';
import { SelectValue } from 'antd/lib/select';

import ua from 'locales/ua/translation.json';
import { UAD_WIM_STATUSES } from 'app-constants/static-dictionaries';
import { StyledSelect, StyledSelectWithLabel, StyledLabel } from './styles';

type WimStatusLocalesKey = keyof typeof ua.wim.status;

interface SelectWimStatusProps {
  name: string;
  onChange: (value: SelectValue) => void;
  value?: string;
}

const { Option } = Select;

export const FormikSelectWimStatus: FC<SelectWimStatusProps> = ({ name, value, onChange }) => {
  const { t } = useTranslation();

  return (
    <StyledSelectWithLabel>
      <StyledLabel>{t('infoFields.status')}</StyledLabel>
      <Field as={StyledSelect} name={name} style={{ width: '100%' }} defaultValue={value} onChange={onChange}>
        {UAD_WIM_STATUSES.map((status: any) => (
          <Option key={`wim-status-${status}`} value={status.value}>
            {t(`wim.status.${status.value as WimStatusLocalesKey}` as const)}
          </Option>
        ))}
      </Field>
    </StyledSelectWithLabel>
  );
};
